/**
 * Taken from https://github.com/Effect-TS/effect/blob/main/packages/schema/src/TreeFormatter.ts
 *
 * If this functionality is ever exposed from Effect, use that instead.
 */

export interface Forest<A> extends ReadonlyArray<Tree<A>> {}

interface Tree<A> {
  readonly value: A;
  readonly forest: Forest<A>;
}

export const makeTree = <A>(value: A, forest: Forest<A> = []): Tree<A> => ({
  value,
  forest,
});

export const drawTree = (tree: Tree<string>): string =>
  tree.value + draw("\n", tree.forest);

const draw = (indentation: string, forest: Forest<string>): string => {
  let r = "";
  const len = forest.length;
  let tree: Tree<string>;
  for (let i = 0; i < len; i++) {
    tree = forest[i];
    const isLast = i === len - 1;
    r += indentation + (isLast ? "└" : "├") + "─ " + tree.value;
    r += draw(indentation + (len > 1 && !isLast ? "│  " : "   "), tree.forest);
  }
  return r;
};
